import React, { Component } from "react";
import {
  Card,
  CardBody,
  Progress,
  Modal,
  ModalBody,
  Input,
  ModalHeader,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
// import AuditPanel from "./audit-panel";
import { apiActions, alertActions, commonActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers, store } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import { connect } from "react-redux";
import { commonService } from "../../_services";
import ViewHeader from "./view-header";
import AccordionItem from "./accordion";
import DetailedItem from "./nestedAccordion";
import ChatIcon from "react-icons/lib/md/chat";
import EmailIcon from "react-icons/lib/md/email";
import CallIcon from "react-icons/lib/md/call";
import WhatsaAppIcon from "react-icons/lib/md/voice-chat";
import CardDetails from "./card-details";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class HelpCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      records: null,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      activeIndex: null,
      details: null,
      modalOpen: false,
      searchInput: "", // New state for search input
      filteredRecords: null, // New state for filtered records
      selectedIndex: 0
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    const reduxState = store.getState();
    const { user } = this.props;
    // const script = document.createElement("script");
    // script.async = true;
    // script.src = 'https://embed.tawk.to/58bfd6885b8fe5150eed9b24/default';
    // script.charset = 'UTF-8';
    // script.setAttribute('crossorigin', '*');
    // script.onload = () => {
    //   // After script is loaded, initialize Tawk_API
    //   if (typeof Tawk_API !== 'undefined') {
    //     Tawk_API.onLoad = this.openLiveChat; // Set onLoad callback to openLiveChat function
    //   }
    // }
    // document.head.appendChild(script);
    this.getFaq();
  }

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  getFaq = (pageNumber = 0) => {
    const { dispatch } = this.props;
    const { pageSize } = this.state;
    dispatch(apiActions.startRequest());
    let payload__ = {
      pageSize: pageSize,
      pageNumber: pageNumber,
      parameter: {
        // query: search,
        productName: "AVICOLLECT",
        status: 3,
      },
    };
    commonService
      .getFaqs(payload__)
      .then((res) => {
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({
            currentPage: pageNumber === 0 ? 1 : pageNumber,
            records: response.data.object,
            totalCount: response.data.TotalCount,
            dataContent: response.data.object[0].content,
          });
          dispatch(apiActions.endRequest());
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(
            alertActions.error(
              appHelpers.interpretErrorResponseAlt2(res.response)
            )
          );
          dispatch(apiActions.endRequest());
        }
      })
      .catch((err) => {
        dispatch(
          alertActions.error(appHelpers.interpretErrorResponseAlt2(err))
        );
        dispatch(apiActions.endRequest());
      });
  };

  generateAccordionData = () => {
    const { filteredRecords, records } = this.state;
    const data = filteredRecords || records;

    return data.reduce((acc, record) => {
      const existingCategory = acc.find(
        (item) => item.categoryName === record.categoryName
      );
      console.log(existingCategory, "cat");
      if (existingCategory) {
        const titleLines = record.title.split("\n");
        existingCategory.titles.push(...titleLines);
        const contentLines = record.content.split("\n"); // Split content into lines
        existingCategory.content.push(...contentLines); // Push content lines
      } else {
        acc.push({
          categoryName: record.categoryName,
          titles: record.title.split("\n"),
          content: record.content.split("\n"), // Split content into lines
        });
      }
      return acc;
    }, []);
  };

  // generateAccordionData = () => {
  //   const { filteredRecords, records } = this.state;
  //   const data = filteredRecords || records;

  //   const categories = {};

  //   data.forEach((record) => {
  //     const { categoryName, title, content } = record;

  //     if (!categories[categoryName]) {
  //       categories[categoryName] = {
  //         categoryName,
  //         items: [],
  //       };
  //     }

  //     categories[categoryName].items.push({
  //       title: title.split("\n"), // Split the title into lines
  //       content: content.split("\n"), // Split the content into lines
  //     });
  //   });

  //   return Object.values(categories);
  // };

  handleSearchInputChange = (event) => {
    const { value } = event.target;
    const { records } = this.state;

    // Filter records based on the search input
    const filteredRecords = records.filter((record) =>
      record.title.toLowerCase().includes(value.toLowerCase())
    );

    this.setState({
      searchInput: value,
      filteredRecords,
    });
    console.log(filteredRecords, "rec");
  };

  toggleAccordion(index) {
    this.setState((prevState) => ({
      activeIndex: prevState.activeIndex === index ? null : index,
    }));
  }

  showDetails = (details) => {
    this.setState({
      details: {
        firstContent: details.firstContent,
        subContent: details.subContent,
      },
    });
    console.log(details, "who");
  };

  // showDetails = (categoryName, itemIndex) => {
  //   const category = this.state.details[categoryName];
  //   const selectedItem = category.items[itemIndex];
  //   const selectedTitle = selectedItem.title.join("\n");
  //   const selectedContent = selectedItem.content.join("\n");

  //   this.setState({
  //     details: {
  //       firstContent: selectedTitle,
  //       subContent: selectedContent,
  //     },
  //   });
  // };

  handleIndexSelected = (index) => {
    this.setState({
      selectedIndex: index
    })
  }
 

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }));
  };

  openWhatsAppChat = () => {
    window.open("https://wa.me/+2347046270754", "_blank");
  };

  callPhoneNumber = () => {
    window.open("tel:+2347046270753");
  };

  sendEmail = () => {
    window.location.href = "mailto:support@avitech.ng";
  };

  openLiveChat = () => {
    if (typeof Tawk_API !== "undefined") {
      // Tawk_API.toggle();
    }
  };
  render() {
    const { requesting, pageRequesting, user, filteredRecords, searchInput } =
      this.props;
    const {
      contentError,
      records,
      selectedIndex,
      details,
    } = this.state;
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody>
                <Row style={{ marginRight: "45%" }}>
                  <Col md={"6"}>
                    <p>
                      Hi{" "}
                      <strong>{this.props.user.fullName.split(" ")[0]}</strong>,
                      How can we help?
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col md={"4"}>
                    <FormGroup>
                      <div className="input-group">
                        <Input
                          type="text"
                          name="search"
                          //   onChange={this.handleInputChange}
                          id="search"
                          //   value={search}
                          className="form-control"
                          placeholder="Search"
                          value={searchInput}
                          onChange={this.handleSearchInputChange}
                        />
                        <div className="input-group-append">
                          <span className="input-group-text">
                            <i className="ti-search"></i>
                          </span>
                        </div>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <div className="clearfis">&nbsp;</div>

                <CardBody>
                  <Row>
                    <Col md={4}>
                      {/* Accordion Items */}
                      {!pageRequesting && records && (
                        <div>
                          <Row style={{ marginRight: "72%" }}>
                            <Col md={"6"}>
                              <p
                                style={{
                                  fontSize: "12px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Faq Categories
                              </p>
                            </Col>
                          </Row>
                          {this.generateAccordionData().map(
        
                            (groupedData, index) =>
                            {  console.log(groupedData, "grouped"); 
                              
                             return <AccordionItem 
                                key={index}
                                title={groupedData.categoryName}
                                showDetails={this.showDetails}
                                subContent={groupedData.content}
                                firstContent={groupedData.titles}
                                handleSelectedIndex={this.handleIndexSelected.bind(this)}
                              />
                              
                                  }
                          )}
                          
                        </div>
                      )}
                    </Col>
                    {!pageRequesting && !records && (
                      <PageEmptyContent message="No record match your search!" />
                    )}
                    <Col md={8} className="detailed-item-col">
                      {/* DetailedItem */}
                      {details && (
                        <DetailedItem
                          contentTitle={details.firstContent}
                          subContent={details.subContent}
                          selectedIndex={selectedIndex}
                        />
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </CardBody>
            )}
            <Row style={{ marginRight: "46%" }}>
              <Col md={4}>
                <p className="help-text">Need more help?</p>
              </Col>
            </Row>
            <Row style={{ marginRight: "40%" }}>
              <Col md={4}>
                <p className="support-modal" onClick={this.toggleModal}>
                  Talk to support
                </p>
              </Col>
            </Row>
            <NotificationSystem ref="notificationSystem" />
          </Card>

          <Modal isOpen={this.state.modalOpen} toggle={this.toggleModal}>
            <ModalHeader toggle={this.toggleModal}></ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col-md-6">
                  <CardDetails
                    icon={<ChatIcon size="15" />}
                    item1="Live Chat"
                    item2="chat with a representative with our chat box on your screen"
                    // item3="click here"
                    onClickItem={this.openLiveChat}
                  />
                </div>
                <div className="col-md-6">
                  <CardDetails
                    icon={<EmailIcon size="15" />}
                    item1="Email us"
                    item2="We'll reply in one business day"
                    item3="support@avitech.ng"
                    onClickItem={this.sendEmail}
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-6">
                  <CardDetails
                    icon={<CallIcon size="15" />}
                    item1="call us"
                    item2="speak with a representative"
                    item3="+234 704 627 0753"
                    onClickItem={this.callPhoneNumber}
                  />
                </div>
                <div className="col-md-6">
                  <CardDetails
                    icon={<WhatsaAppIcon size="15" />}
                    item1="whatsaApp"
                    item2="chat with a representative"
                    item3="+234 704 627 0754"
                    onClickItem={this.openWhatsAppChat}
                  />
                </div>
              </div>
            </ModalBody>
          </Modal>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { loggingIn, user } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { alert, manifestReports, airlinesCarriers } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    alert,
    manifestReports,
    airlinesCarriers,
    user,
  };
}

export default connect(mapStateToProps)(HelpCenter);



// WEBPACK FOOTER //
// ./src/views/help-center/index.js